import dayjs from 'dayjs';
import durationPlugin from 'dayjs/plugin/duration';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from '@/components/Button';
import TooltipLarge from '@/components/TooltipLarge';
import { DOCUMENT_TTL_HOURS } from '@/config';
import { useMediaQuery } from '@/hooks';
import { useIsTrialing } from '@/hooks/user';
import Clock from '@/icons/clock.svg';
import routes from '@/routes';
import { setIsModalTimerOpen } from '@/store/myDocuments';

dayjs.extend(durationPlugin);

function Timer({ createdAt, tooltip = true }) {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const mdDown = useMediaQuery('mdDown');
	const navigate = useNavigate();

	const isTrialing = useIsTrialing();

	// get state to re-render every minute
	useSelector(state => state.myDocuments.minutes);

	if (!createdAt) {
		return null;
	}

	const endOfLife = dayjs.unix(createdAt).add(DOCUMENT_TTL_HOURS, 'hours');
	const timeLeftMinutes = endOfLife.diff(dayjs(), 'minutes');
	const duration = dayjs.duration(Math.max(timeLeftMinutes, 0), 'minutes');

	const content = (
		<div className="flex h-8 items-center gap-1 rounded-sm bg-grey-100 px-2 text-[10px] font-semibold leading-none text-gray-500 md:h-6 md:px-1">
			<Clock className="h-[14px] w-[14px]" />
			<span className="mt-[1px] inline-block">
				{duration.format('HH:mm')}
			</span>
		</div>
	);

	if (tooltip) {
		return mdDown ? (
			<Button
				className="p-0"
				onClick={() => {
					dispatch(setIsModalTimerOpen(true));
				}}
				variant="ghost"
			>
				{content}
			</Button>
		) : (
			<TooltipLarge
				title={t('myDocuments.timerTitle')}
				description={t('myDocuments.timerDescription')}
				actionText={t('myDocuments.timerAction')}
				onClick={() =>
					navigate(routes.billing, {
						state: { openChangePlanModal: isTrialing }
					})
				}
			>
				{content}
			</TooltipLarge>
		);
	}

	return content;
}

export default Timer;
